{
  "home": {
    "pageTitle": "DEC Energy | Energy-Fintech per la transizione energetica",
    "description": "Soluzioni energy-fintech che ridefiniscono produzione e consumo di energia rinnovabile. Scopri DEC Energy per aziende e produttori.",
    "ogTitle": "DEC Energy - Energy-Fintech per la transizione energetica",
    "ogDescription": "Soluzioni energy-fintech che ridefiniscono produzione e consumo di energia rinnovabile. Scopri DEC Energy per aziende e produttori."
  },
  "company": {
    "pageTitle": "Riduci i costi energetici con le Garanzie di Origine | DEC Energy",
    "description": "Trasforma l’approvvigionamento rinnovabile in profitto: produci le tue Garanzie di Origine da impianti selezionati e riduci i costi energetici.",
    "ogTitle": "Riduci i costi energetici - DEC Energy",
    "ogDescription": "Trasforma l’approvvigionamento rinnovabile in profitto: produci le tue Garanzie di Origine da impianti selezionati e riduci i costi energetici."
  },
  "companyCalendly": {
    "pageTitle": "Prenota un appuntamento - Aziende | DEC Energy",
    "description": "Prenota un appuntamento per scoprire come rendere redditizio il tuo consumo di Garanzie di Origine",
    "ogTitle": "Prenota un appuntamento - DEC Energy",
    "ogDescription": "Prenota un appuntamento per scoprire come rendere redditizio il tuo consumo di Garanzie di Origine"
  },
  "companyEnergyManager": {
    "pageTitle": "Per energy manager | DEC Energy",
    "description": "Rendi redditizio l’approvvigionamento di energia rinnovabile",
    "ogTitle": "Per energy manager - DEC Energy",
    "ogDescription": "Rendi redditizio l’approvvigionamento di energia rinnovabile"
  },
  "companyProduct": {
    "pageTitle": "Il modello DEC Energy per aziende | DEC Energy",
    "description": "Contrattualizza impianti fotovoltaici per produrre le tue Garanzie di Origine e profitti",
    "ogTitle": "Il modello DEC Energy per aziende",
    "ogDescription": "Contrattualizza impianti fotovoltaici per produrre le tue Garanzie di Origine e profitti"
  },
  "companySustainabilityManager": {
    "pageTitle": "Per sustainability manager | DEC Energy",
    "description": "Contribuisci alla transizione energetica con un impatto reale e comunicabile",
    "ogTitle": "Per sustainability manager - DEC Energy",
    "ogDescription": "Contribuisci alla transizione energetica con un impatto reale e comunicabile"
  },
  "producer": {
    "pageTitle": "Per produttori | DEC Energy",
    "description": "Ricevi cassa anticipata sui tuoi impianti e fai derisking di prezzi e produzione",
    "ogTitle": "Per produttori - DEC Energy",
    "ogDescription": "Ricevi cassa anticipata sui tuoi impianti e fai derisking di prezzi e produzione"
  },
  "producerCalendly": {
    "pageTitle": "Prenota un appuntamento - Produttori | DEC Energy",
    "description": "Prenota un appuntamento per scoprire come ricevere cassa anticipata dai tuoi impianti",
    "ogTitle": "Prenota un appuntamento - DEC Energy",
    "ogDescription": "Prenota un appuntamento per scoprire come ricevere cassa anticipata dai tuoi impianti"
  },
  "producerIpps": {
    "pageTitle": "Per produttori indipendenti | DEC Energy",
    "description": "Sblocca il pieno potenziale del tuo capitale e accresci il tuo portafoglio di asset",
    "ogTitle": "Per produttori indipendenti - DEC Energy",
    "ogDescription": "Sblocca il pieno potenziale del tuo capitale e accresci il tuo portafoglio di asset"
  },
  "producerProduct": {
    "pageTitle": "Il modello DEC Energy per produttori | DEC Energy",
    "description": "Ricevi cassa anticipata e derisking sui tuoi asset",
    "ogTitle": "Il modello DEC Energy per produttori",
    "ogDescription": "Ricevi cassa anticipata e derisking sui tuoi asset"
  },
  "producerUtility": {
    "pageTitle": "Per utility | DEC Energy",
    "description": "Accelera la tua transizione energetica mantenendo la proprietà dei tuoi impianti",
    "ogTitle": "Per utility - DEC Energy",
    "ogDescription": "Accelera la tua transizione energetica mantenendo la proprietà dei tuoi impianti"
  },
  "contactForm": {
    "pageTitle": "Contatta i nostri esperti | DEC Energy",
    "description": "Compila il form per essere contattato da uno dei nostri esperti",
    "ogTitle": "Contatta i nostri esperti - DEC Energy",
    "ogDescription": "Compila il form per essere contattato da uno dei nostri esperti"
  },
  "aboutUs": {
    "pageTitle": "Chi siamo | DEC Energy",
    "description": "Scopri come a DEC Energy stiamo costruendo strumenti fintech che ridefiniscono produzione e consumo di energia rinnovabile",
    "ogTitle": "Chi siamo - DEC Energy",
    "ogDescription": "Scopri come a DEC Energy stiamo costruendo strumenti fintech che ridefiniscono produzione e consumo di energia rinnovabile"
  },
  "blog": {
    "pageTitle": "DEC Insights | DEC Energy",
    "description": "Leggi i nostri articoli dedicati alle energie rinnovabili, alla sostenibilità e alle ultime notizie del settore.",
    "ogTitle": "DEC Insights - DEC Energy",
    "ogDescription": "Leggi i nostri articoli dedicati alle energie rinnovabili, alla sostenibilità e alle ultime notizie del settore."
  },
  "decExplorer": {
    "pageTitle": "DEC Explorer | DEC Energy",
    "description": "Quantifica i tuoi risparmi adottando il modello DEC Energy",
    "ogTitle": "DEC Explorer - DEC Energy",
    "ogDescription": "Quantifica i tuoi risparmi adottando il modello DEC Energy"
  },
  "faq": {
    "pageTitle": "FAQ | DEC Energy",
    "description": "Trova tutte le risposte alle domande più frequenti",
    "ogTitle": "FAQ - DEC Energy",
    "ogDescription": "Trova tutte le risposte alle domande più frequenti"
  },
  "producerIppLight": {
    "pageTitle": "IPP Light | DEC Energy",
    "description": "La soluzione DEC Energy per piccoli produttori di energia rinnovabile",
    "ogTitle": "IPP Light - DEC Energy",
    "ogDescription": "La soluzione DEC Energy per piccoli produttori di energia rinnovabile"
  },
  "solutionRiduzione": {
    "pageTitle": "Riduzione prevedibile dei costi energetici | DEC Energy",
    "description": "Riduci ulteriormente i tuoi costi energetici in modo prevedibile con DEC Energy",
    "ogTitle": "Riduzione prevedibile - DEC Energy",
    "ogDescription": "Riduci ulteriormente i tuoi costi energetici in modo prevedibile con DEC Energy"
  },
  "solutionConformita": {
    "pageTitle": "Conformità future-proof | DEC Energy",
    "description": "Trasforma il costo della conformità in ricavi operativi ricorrenti con DEC Energy",
    "ogTitle": "Conformità - DEC Energy",
    "ogDescription": "Trasforma il costo della conformità in ricavi operativi ricorrenti con DEC Energy"
  },
  "solutionEbitda": {
    "pageTitle": "Migliora l'EBITDA | DEC Energy",
    "description": "Migliora la tua redditività operativa con la soluzione DEC Energy",
    "ogTitle": "EBITDA - DEC Energy",
    "ogDescription": "Migliora la tua redditività operativa con la soluzione DEC Energy"
  },
  "solutionCoperturaNaturale": {
    "pageTitle": "Copertura naturale dei costi | DEC Energy",
    "description": "Neutralizza le oscillazioni del tuo costo energetico per i prossimi 10 anni",
    "ogTitle": "Copertura naturale - DEC Energy",
    "ogDescription": "Neutralizza le oscillazioni del tuo costo energetico per i prossimi 10 anni"
  },
  "solutionImpatto": {
    "pageTitle": "Impatto sostenibile | DEC Energy",
    "description": "Eleva la tua transizione energetica con una soluzione concreta e comunicabile",
    "ogTitle": "Impatto - DEC Energy",
    "ogDescription": "Eleva la tua transizione energetica con una soluzione concreta e comunicabile"
  },
  "capital": {
    "pageTitle": "DEC Capital, quote di ricavi da impianti rinnovabili | DEC Energy",
    "description": "Quote dei ricavi di impianti rinnovabili già in esercizio in Italia: rendimento da asset reali e protezione contrattuale, senza acquistare gli asset.",
    "ogTitle": "DEC Capital - DEC Energy",
    "ogDescription": "Quote dei ricavi di impianti rinnovabili già in esercizio in Italia: rendimento da asset reali e protezione contrattuale, senza acquistare gli asset."
  },
  "notFound": {
    "pageTitle": "Pagina non trovata | DEC Energy",
    "description": "La pagina che cerchi non esiste. Torna alla home di DEC Energy o scrivici.",
    "ogTitle": "Pagina non trovata - DEC Energy",
    "ogDescription": "La pagina che cerchi non esiste. Torna alla home di DEC Energy o scrivici."
  },
  "publicProfile": {
    "pageTitle": "Profilo pubblico | DEC Energy",
    "description": "Il profilo pubblico di un'azienda su DEC Energy: i suoi impianti, la produzione e l'impatto della sua energia rinnovabile.",
    "ogTitle": "Profilo pubblico - DEC Energy",
    "ogDescription": "Il profilo pubblico di un'azienda su DEC Energy: i suoi impianti, la produzione e l'impatto della sua energia rinnovabile."
  }
}
